export function telemetrySessionKey(session) {
  if (!session) return "";
  if (session.sessionUuid) return `uuid:${session.sessionUuid}`;
  return `op:${session.operatorId}:${session.assumedAt}:${session.machineIdent || ""}`;
}

export function nextTelemetryPopup(previousKeys, sessions, { popupOpen } = {}) {
  const list = Array.isArray(sessions) ? sessions : [];
  const currentKeys = list.map(telemetrySessionKey);
  if (previousKeys == null) {
    return { popup: null, keys: new Set(currentKeys) };
  }
  if (popupOpen) {
    return { popup: null, keys: previousKeys };
  }
  const unseen = list.filter(
    (item) => !previousKeys.has(telemetrySessionKey(item))
  );
  const keys = new Set(previousKeys);
  currentKeys.forEach((key) => keys.add(key));
  return { popup: unseen[0] || null, keys };
}

export function markTelemetrySessionsSeen(previousKeys, sessions) {
  const keys = new Set(previousKeys || []);
  (sessions || []).forEach((item) => keys.add(telemetrySessionKey(item)));
  return keys;
}

export function assumeRelativeParts(assumedAt, now = new Date()) {
  const then = new Date(assumedAt);
  if (Number.isNaN(then.getTime())) {
    return { unit: "now", count: 0 };
  }
  const diffMs = Math.max(0, now.getTime() - then.getTime());
  const minutes = Math.floor(diffMs / 60000);
  if (minutes < 1) return { unit: "now", count: 0 };
  if (minutes < 60) return { unit: "minutes", count: minutes };
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return { unit: "hours", count: hours };
  return { unit: "days", count: Math.floor(hours / 24) };
}

export function dayKeyFromAssumedAt(assumedAt) {
  if (!assumedAt) return "";
  const date = new Date(assumedAt);
  if (Number.isNaN(date.getTime())) {
    return String(assumedAt).slice(0, 10);
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function buildFieldAppTrackingHref(farmId, session) {
  if (!farmId || !session) return "";
  const params = new URLSearchParams();
  params.set("tab", "tracking");
  if (session.operatorId) params.set("operator", String(session.operatorId));
  if (session.machineIdent) params.set("machine", session.machineIdent);
  const day = dayKeyFromAssumedAt(session.assumedAt);
  if (day) params.set("day", day);
  if (session.sessionUuid) params.set("session", session.sessionUuid);
  return `/${farmId}/field-app/?${params.toString()}`;
}
